import ShPopDelButton from './src/main.vue'

ShPopDelButton.install = function (Vue) {
  Vue.component(ShPopDelButton.name, ShPopDelButton)
}
export default ShPopDelButton
